<template>
  <div>
    <v-row>
      <v-col cols="12" sm="2">
        <v-checkbox
          v-model='analytics.status'
          label="Включен"
          outlined
          dense
          hide-details
          class="checkbox ma-0 checkbox-direction"
          flat
          true-value="A"
          false-value="D"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-row v-if="analytics.status === 'A'">
      <v-col cols="12" sm="3">
        <v-text-field
          label="Кадров в секунду"
          type="number"
          outlined
          v-model="analytics.frame_rate"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          label="Задержка перед открытием двери"
          type="number"
          outlined
          v-model="analytics.door_open_delay"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          label="Задержка распознавания"
          type="number"
          outlined
          v-model="analytics.recognition_delay"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          label="Точноть (%)"
          type="number"
          outlined
          v-model="analytics.tolerance"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="d-flex my-2">
          <v-btn
            large
            color="success"
            class="text-none ml-auto"
            dark
            @click="save()"
          >
            Сохранить
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Analytics',
  data: () => ({
    analytics: {
      status: 'D',
      frame_rate: 0,
      door_open_delay: 0,
      recognition_delay: 0,
      tolerance: 0,
    },
  }),
  methods: {
    ...mapActions({
      loadInfo: 'Doorphone/analyticsInfo',
      changeParams: 'Doorphone/changeAnalyticsParams',
    }),
    save () {
      this.changeParams({
        id: this.$route.params.id,
        status: this.analytics.status,
        frame_rate: this.analytics.frame_rate,
        door_open_delay: this.analytics.door_open_delay,
        recognition_delay: this.analytics.recognition_delay,
        tolerance: this.analytics.tolerance,
      })
        .then(() => {
          this.$flash_success('Параметры аналитики успешно изменен');
        })
        .catch(e => {
          this.$flash_warning(e.response.data.error);
        });
    },
  },
  mounted () {
    this.loadInfo({
      id: this.$route.params.id,
    })
      .then(doorphone => {
        Object.keys(this.analytics).forEach(key => {
          this.analytics[key] = doorphone[key] || 0;
        });
      })
      .catch((err) => {
        if (err.response && err.response.status === 400) {
          const error = err.response.data.error;
          this.$flash_warning('Ошибка: ' + error);
        } else {
          this.$flash_warning('Ошибка загрузки информации');
        }
      });
  },
};
</script>
